import moment from 'moment';
import React from 'react';
import { Select, Tooltip, Modal } from 'antd';

const Option = Select.Option;

/**
 * 操作之前的确认弹框
 * @param {*} messag 弹框中部展示文本
 * @param {*} handleOk 确认按钮点击事件，
 * @param {*} handleCancel 取消按钮点击事件
 * @param {*} content 提示信息
 */
export function confirm(messag, handleOk, handleCancel, content) {
  Modal.confirm({
    title: messag,
    content: content,
    onOk: handleOk,
    onCancel: handleCancel,
    okButtonProps: { id: 'confirmOk' },
    cancelButtonProps: { id: 'confirmCancel' }
  });
}

/**
 * 修改数组某条数据对应的部分字段值，返回修改后数组
 * @param {*} dataSource 原数组
 * @param {*} id table key值
 * @param {*} changeInfo 修改项对象
 * @returns 新数组
 * 使用例子：DepartmentManagement.js
 */
export function getNewData(dataSource, id, changeInfo) {
  const newData = [...dataSource];
  const index = newData.findIndex(item => id === item.id);
  if (index > -1) {
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...changeInfo });
  }
  return newData;
};

/**
 * 表格前端排序（列定义中使用）
 * @param {*} a 记录1
 * @param {*} b 记录2
 * 使用例子：sorter: (a, b) => this.sortData(a.itemCode, b.itemCode)
 */
export function sortData(a, b) {
  // 数字排序
  if (Number.isFinite(a) && Number.isFinite(b)) {
    return a - b;
  }

  // 字符串排序
  return String(a).localeCompare(String(b));
};

// 获取当前时间上一个月第一天
/** 废弃-迁移至 DateUtil.js中 */
export function getLastMonthFirstDay() {
  return moment().month(moment().month() - 1).startOf('month');
};

// 获取当前时间上一个月第一天与当前时间数组
/** 废弃-迁移至 DateUtil.js中 */
export function getLastMonthFirstDayToNow() {
  return [getLastMonthFirstDay(), moment()];
};

/**
 * 设置选择器元素
 */
export const getOptionList = (data) => {
  if (!data) {
    return [];
  }
  return data.map((item) =>
    (<Option value={item.key} key={item.key} disabled={item.disabled} className={item.disabled ? 'disabledClass' : ''}>{item.value}</Option>)
  );
};

/**
 * 设置选择器元素(带提示)
 */
export const getTooltipOptionList = (data) => {
  if (!data) {
    return [];
  }
  return data.map((item) =>
    (<Option value={item.key} key={item.key} disabled={item.disabled} className={item.disabled ? 'disabledClass' : ''}><Tooltip title={item.value}>{item.value}</Tooltip></Option>)
  );
};

/**
 * 设置选择器元素(key值为value)
 */
export const getOptionValueList = (data) => {
  if (!data) {
    return [];
  }
  // 去重value值
  const tmp = [];
  const result = [];
  data.forEach(item => {
    if (!tmp[item.value]) {
      tmp.push(item.value);
      result.push(<Option value={item.value} key={item.value} disabled={item.disabled} className={item.disabled ? 'disabledClass' : ''}>{item.value}</Option>);
    }
  });
  return result;
};
